import { render, staticRenderFns } from "./SearchCriterial.vue?vue&type=template&id=15af440b&"
import script from "./SearchCriterial.vue?vue&type=script&lang=js&"
export * from "./SearchCriterial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports